'use client';
import { polyfillResolve } from './manifest.utils.js';

let t = [];
function getSwanScriptPolyfillUrl(t, l) {
    return polyfillResolve(t, l);
}
function generatePolyfillElements(e) {
    let l = document.createDocumentFragment();
    return t.forEach((t)=>{
        let { loadCondition: r, scriptFileName: n } = t;
        if (r() && n) {
            let t = getSwanScriptPolyfillUrl(n, e);
            if (!document.querySelector(`script[src="${t}"]`)) {
                let e = document.createElement('script');
                e.src = t, e.type = 'text/javascript', e.defer = true, l.appendChild(e);
            }
        }
    }), {
        scriptFragment: l
    };
}
const loadSwanPolyfill = (e)=>{
    let { scriptFragment: t } = generatePolyfillElements(e);
    document.head.appendChild(t);
};

export { getSwanScriptPolyfillUrl, loadSwanPolyfill };
